import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { selectFactoids } from '../../selectors';
import { Factoids } from '../../components/Factoids';

export const FactoidsContainer = () => {
  const factoids = useSelector(selectFactoids, shallowEqual);

  if (!factoids.length) {
    return null;
  }

  return <Factoids factoids={factoids} />;
};
